import * as z from "../../../framework";
import { userHasRight } from "../../../framework";
import { Component, ComponentOptions, RightLockable } from "../../../framework/components/components/component";
import { TemplateComponent } from "../../../framework/components/components/templateComponent";
import K_InsertObjectGroup from "../templates/K_InsertObjectGroup";

export interface InsertObjectGroupOptions extends ComponentOptions {
    components?: Component[];
    woopContainers?: Component[];
    insertObjectGroupLabel?: string;
    bsc?: string;
    requiredRight?: string;
}

export class InsertObjectGroup extends TemplateComponent {

    options: InsertObjectGroupOptions & RightLockable;
    content: {
        components: Component[];
        woopContainers: Component[];
    };

    constructor(options: InsertObjectGroupOptions) {
        super(K_InsertObjectGroup, options);

        this.content = {
            components: options.components || [],
            woopContainers: options.woopContainers || []
        };
    }

    preRender() {
        const options = this.options;

        options.insertObjectGroupLabel = options.insertObjectGroupLabel || z.ll("Insert", true);

        if (options.requiredRight) {
            options.rightLocked = !userHasRight(options.requiredRight);

            if (options.rightLocked) {
                options.disabled = true;
                options.containerClasses += " disabled right-locked";
            }
        }
    }

}
